/**
 * Because older browsers will interpret any object in the 3rd argument
 * as a true value for the capture argument, it's important for developers
 * to use feature detection or a polyfill when using this API, to avoid
 * unforeseen results.
 * Resource: https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */
let supportsCaptureOption = false;

try {
  const opts = Object.defineProperty({}, 'capture', {
    get() {
      supportsCaptureOption = true;
    },
  });

  window.addEventListener('test', null, opts);
  window.removeEventListener('test', null, opts);
  // eslint-disable-next-line no-empty
} catch {}

interface SafeEventHandlerOpts {
  capture?: true;
  passive?: false;
}

export const getSafeEventHandlerOpts = (options: SafeEventHandlerOpts = { capture: true }) =>
  supportsCaptureOption ? options : options.capture;
